function Footer() {
    return (
        <footer className="py-6 bg-white mt-auto shadow-inner">
            <div className="max-w-5xl mx-auto px-4 text-center text-sm text-gray-600">
                <p>© 2025 William Katz. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;